<template>
  <div v-if="revisionsWithLength.length > 0 || commentVisible" class="mt-3 lisaui:border-0">
    <div>
      <span class="border-bottom border-secondary lisaui:inline-block w-100">
        {{ t("components.eventAction.task.TaskCommentSection.title") }}
        <div class="lisaui:flex">
          <hr class="w-100" />
        </div>
      </span>
    </div>
    <EventActionRevisionList
      :revisions="minimumRevisions"
      :event-action-type-fields="eventActionTypeFields"
      :board-event-connections="boardEventConnections"
    />
    <EventActionCreateComment
      v-if="commentVisible && archived === false"
      :event-id="eventId"
      :action-id="actionId"
      class="mt-2"
      :original-board-id="originalBoardId"
      @comment-added="commentVisible = false"
    />
  </div>
</template>

<script setup lang="ts">
import { useTranslation } from "@/language/translation";

import { computed, type PropType } from "vue";
import type {
  EABEventActionConfigType,
  EABEventActionType,
  EABEventType,
} from "./EventActionHelper";
import EventActionRevisionList from "./EventActionRevisionList.vue";
import EventActionCreateComment from "./EventActionCreateComment.vue";
const props = defineProps({
  eventId: {
    type: Number,
    required: false,
    default: undefined,
  },
  actionId: {
    type: Number,
    required: false,
    default: undefined,
  },
  revisions: {
    type: Array as PropType<
      EABEventActionType["SQDCActionRevisions"] | EABEventType["SQDCEventRevisions"]
    >,
    required: true,
  },
  archived: {
    type: Boolean,
    required: false,
    default: false,
  },
  originalBoardId: {
    type: Number,
    required: false,
    default: undefined,
  },
  eventActionTypeFields: {
    type: Array as PropType<EABEventActionConfigType["SQDCEventActionTypeFields"]>,
    required: false,
    default: () => [],
  },
  boardEventConnections: {
    type: Array as PropType<EABEventType["BoardEventConnection"]>,
    required: false,
    default: () => [],
  },
});
const commentVisible = defineModel("commentVisible", {
  type: Boolean,
  default: false,
});
const MINIMUM_NUMBER_OF_COMMENTS = 5;
const revisionsWithLength = computed(
  () =>
    props.revisions
      .map((el) => {
        const changes = (el.changes ?? []).filter((change) => change.includeInLast !== false);
        return {
          ...el,
          changes,
          length: changes.length + (el.comment ? 1 : 0),
        };
      })
      .filter((revision) => revision.length > 0) ?? [],
);
const minimumRevisions = computed(() => {
  let visibleRevisions: typeof revisionsWithLength.value = [];
  let currentLength = 0;
  for (let i = revisionsWithLength.value.length - 1; i >= 0; i--) {
    const rev = revisionsWithLength.value[i];
    if (rev.length > 0 && currentLength < MINIMUM_NUMBER_OF_COMMENTS) {
      visibleRevisions.push(rev);
      currentLength += rev.length;
    }
    if (currentLength >= MINIMUM_NUMBER_OF_COMMENTS) {
      break;
    }
  }
  return visibleRevisions as typeof props.revisions;
});

const { t } = useTranslation();
</script>

<style lang="scss" scoped>
.commentGrid {
  display: grid;
  gap: 4px;
  grid-template-columns: min-content max-content auto;
  align-items: baseline;
  .date {
    white-space: nowrap;
  }
}
</style>
